import { VEBPlanName } from "../types/plan.types";

export const type1EligiblityMessage =
	"Employees must be age 18 or older to enroll\n\n employees who are under the age of 18 are not eligible for enrollment and the portal will not allow benefit selections.";
export const type2EligiblityMessage =
	"Your are ineligible for this plan. \n\nMinimum age for enrollment is 18 and Maximum age for enrollment is 70";
const VEBEligiblityMessage: { [key in VEBPlanName]: string } = {
	Cancer: type1EligiblityMessage,
	Accident: type1EligiblityMessage,
	"Critical Illness": type1EligiblityMessage,
	Dental: type1EligiblityMessage,
	"Doc and Rx": type1EligiblityMessage,
	"Group Life Indemnity": type1EligiblityMessage,
	"Hospital Indemnity": type1EligiblityMessage,
	"Short Term Disability":
		"You are are ineligible for this plan. \n\nMinimum age for enrollment is 18 and Maximum age for enrollment is 64",
	Vision: type1EligiblityMessage,
	"Whole life": type2EligiblityMessage,
	"Family Protection": type2EligiblityMessage
};

export const type1EligiblityPromptMessage = "Min age is 18";
export const type2EligiblityPromptMessage = "Min age is18  & Max age is - 70 (Spouse), 26 (Child)";

const VEBEligiblityPromptMessage: { [key in VEBPlanName]: string } = {
	Cancer: type1EligiblityPromptMessage,
	Accident: type1EligiblityPromptMessage,
	"Critical Illness": type1EligiblityPromptMessage,
	Dental: type1EligiblityPromptMessage,
	"Doc and Rx": type1EligiblityPromptMessage,
	"Group Life Indemnity": type1EligiblityPromptMessage,
	"Hospital Indemnity": type1EligiblityPromptMessage,
	"Short Term Disability": type1EligiblityPromptMessage,
	Vision: type1EligiblityPromptMessage,
	"Whole life": type2EligiblityPromptMessage,
	"Family Protection": type2EligiblityPromptMessage
};

export const VEB_ELIGIBLITY_MESSAGE = VEBEligiblityMessage;
export const VEB_ELIGIBLITY_PROMPT_MESSAGE = VEBEligiblityPromptMessage;
